import { PreloadedState, combineReducers, configureStore } from '@reduxjs/toolkit';
import {
    // FLUSH,
    // PAUSE,
    // PERSIST,
    // PURGE,
    // REGISTER,
    // REHYDRATE,
    persistReducer,
    persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { apiSlice } from '../api/apiSlice';
import authReducer from '../pages/login/authSlice';
import floatingRecorderReducer from '../features/recordingFeature/floatingRecorderSlice';

const persistConfig = {
    key: 'root',
    storage,
    // Blacklist large/session-only slices:
    // - 'api': RTK Query cache grows to several MB and is rebuilt fresh each session
    // - 'floatingRecorder': session-only recording state; persisting corrupts filenames
    blacklist: ['api', 'floatingRecorder'],
};
const reducer = combineReducers({
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    floatingRecorder: floatingRecorderReducer,
});

export const persistedReducer = persistReducer(persistConfig, reducer);

export const apiMiddlewareConfig = (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
        // serializableCheck: {
        //     ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        // },
        immutableCheck: false,
        serializableCheck: false,
    }).concat(apiSlice.middleware);

export function setupStore(preloadedState?: PreloadedState<RootState>) {
    return configureStore({
        reducer: persistedReducer,
        preloadedState,
        middleware: apiMiddlewareConfig,
        devTools: process.env.NODE_ENV !== 'production',
    });
}

export const store = setupStore();

export const persistor = persistStore(store);
//export type RootState = ReturnType<typeof store.getState>;
export type RootState = ReturnType<typeof persistedReducer>;
